import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    header: {
      minHeight: 69,
      height: 69,
      display: "flex",
      alignItems: "center",
      borderBottom: `1px solid ${primary.light}`,
      padding: "0 24px 0 16px",
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        minHeight: 70,
        height: 70,
        padding: "0 16px 0 8px",
        borderBottom: "1px solid #eee"
      }
    },
    menuButton: {
      height: 45,
      fontSize: 18,
      color: primary.main,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      textTransform: "capitalize",
      "& .MuiButton-endIcon": {
        color: primary.dark,
        marginLeft: 5
      },
      "& .MuiButton-iconSizeMedium > *:first-child": {
        fontSize: 26
      }
    },
    menu: {
      "& .MuiPaper-root": {
        marginTop: 45
      },
      "& .MuiPaper-elevation8": {
        boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.4)"
      }
    },
    menuItem: {
      display: "flex",
      flexDirection: "column",
      borderRadius: 0,
      padding: "9px 20px",
      minWidth: 196,
      textTransform: "capitalize",
      fontSize: 16,
      color: primary.main,
      borderBottom: `1px solid ${primary.light}`,
      "& .MuiButton-label": {
        justifyContent: "flex-start"
      },
      "&.selected": {
        backgroundColor: "rgba(238, 238, 238, 1)"
      }
    },
    content: {
      padding: "6px 24px 24px",
      "&.scrollableContainer": {
        maxHeight: "calc(100vh - 120px)",
        overflowY: "auto",
        overflowX: "hidden",
        paddingBottom: 0
      },
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        padding: "10px 16px 16px"
      }
    }
  };
});
